import {
  Chip,
  Divider,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  updateFormSettings,
  addLanguages,
  setDefaultLanguage,
  removeLanguages,
} from "../actions";

const useStyles = makeStyles((theme) => ({
  grid: {
    padding: theme.spacing(1),
  },
  typo: {
    marginTop: "15px",
  },
  chipList: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const FormSettings = (props) => {
  const [languages, setLanguages] = useState("");
  const classes = useStyles();
  const { dispatch } = props;

  useEffect(()=>{
    dispatch(addLanguages(props.form_languages.join(" ")));
  },[])

  const handleChange = (e) => {
    dispatch(updateFormSettings(e.target.id, e.target.value));
  };

  const handleLanguages = (e) => {
    setLanguages(e.target.value);
  };

  const addLanguage = (e) => {
    if (e.which === 13 || e.charCode === 13) {
      dispatch(addLanguages(e.target.value));
      setLanguages("");
    }
  };

  return (
    <>
      <Typography component="h3" variant="h5" gutterBottom>
        Form Settings
      </Typography>
      <Divider />
      <form>
        <Grid container>
          <Grid item md={6} className={classes.grid}>
            <FormControl required={true} fullWidth={true}>
              <TextField
                id="form_title"
                label="Form Title"
                onChange={handleChange}
                value={props.form_title ? props.form_title : props.family}
              />
            </FormControl>
          </Grid>
          <Grid item md={6} className={classes.grid}>
            <FormControl required={true} fullWidth={true}>
              <TextField
                id="family"
                label="Form Family"
                onChange={handleChange}
                value={props.family}
              />
            </FormControl>
          </Grid>
          
          <Grid item md={6} className={classes.grid}>
            <FormControl margin="normal" required={true} fullWidth={true}>
              <TextField
                id="generation"
                label="Generation"
                onChange={handleChange}
                value={props.generation}
              />
            </FormControl>
            <FormControl
              margin="normal"
              className={classes.control}
              fullWidth={true}
            >
              <TextField
                id="form_id"
                label="Form ID"
                inputProps={{ readOnly: true }}
                // defaultValue={"_G1"}
                value={props.form_id}
                disabled
              />
            </FormControl>
          </Grid>
          <Grid item md={6} className={classes.grid}>
            <FormControl margin="normal" required={true} fullWidth={true}>
              <TextField
                id="instance_name"
                label="Instance Name"
                inputProps={{ readOnly: true }}
                // defaultValue={"concat(${uuid_ssname})"}
                value={props.instance_name}
                disabled
              />
            </FormControl>
            {/* <FormControl margin="normal" required={true} fullWidth={true}>
              <TextField
                id="public_key"
                label="Public Key"
                onChange={handleChange}
                value={props.public_key}
              />
            </FormControl>
            <FormControl margin="normal" required={true} fullWidth={true}>
              <TextField
                id="submission_url"
                label="Submission URL"
                onChange={handleChange}
                value={props.submission_url}
              />
            </FormControl> */}
          </Grid>
        </Grid>
      </form>
      <Divider />
      <Typography
        className={classes.typo}
        component="h3"
        variant="h5"
        gutterBottom
      >
        Languages
      </Typography>

      <FormControl margin="normal" required={true} fullWidth={true}>
        <TextField
          id="language"
          label="Language"
          onKeyPress={addLanguage}
          onChange={handleLanguages}
          value={languages}
        />
      </FormControl>
      <FormHelperText id="language-helper-text">
        Type the language code and enter to create language. <br />
        You also create many languages in once time, type language codes and
        seperate them with space.
      </FormHelperText>
      <ChipList
        dispatch={dispatch}
        languages={props.form_languages}
        default_language={props.default_language}
      />
    </>
  );
};

const ChipList = (props) => {
  const { languages, dispatch } = props;
  const classes = useStyles();

  let languagesChips = [];
  languagesChips = languages.map((language) => {
    return (
      <Chip
        key={`chiplist_language_${language}`}
        // icon={<FaceIcon />}
        label={language}
        color={props.default_language === language ? "secondary" : "primary"}
        onClick={() => {
          dispatch(setDefaultLanguage(language));
        }}
        onDelete={() => {
          dispatch(removeLanguages(language));
        }}
      />
    );
  });
  return (
    <>
      <div className={classes.chipList}>{languagesChips}</div>

      {languagesChips.length > 0 && (
        <FormHelperText id="language-helper-text">
          Click a language tag to select the default language.
        </FormHelperText>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.form_settings,
    form_languages: state.languages,
  };
};

export default connect(mapStateToProps)(FormSettings);
